import { useContext } from 'react';
import { OidcRoutesContext } from '../contexts';

export const useIsSppUser = () => {
  const oidcRoutesContext = useContext(OidcRoutesContext);

  return {
    isSppUser: () => !!oidcRoutesContext?.userProfile?.isSppUser
  };
};
